<template>
  <v-dialog v-model="show" max-width="1200px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              type="text"
              v-model="object.nombre"
              label="Nombre"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="object.prioridad"
              :items="tipoPrioridadArr"
              dense
              label="Prioridad"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              v-model="dateFI"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="object.finish_at"
                  label="Fecha de límite"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_FI"
                @input="dateFI = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
              v-model="object.estado"
              label="Completa"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-textarea v-model="object.comentarios" label="Comentarios" color="cyan"></v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="object" color="blue darken-1" text @click="close">
          Volver
        </v-btn>
        <v-btn v-else color="blue darken-1" text @click="close">
          Cancelar
        </v-btn>
        <v-btn color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      tipoPrioridadArr: [
        { text: "Baja", value: 1 },
        { text: "Media", value: 2 },
        { text: "Alta", value: 3 },
      ],
      date_FI: new Date().toISOString().substr(0, 10),
      dateFI: false,
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
  },
  computed: {
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edución de tarea";
      } else {
        titulo = "Nueva tarea";
      }
      // this.update ? "Edución de registro" : "Nuevo registro";
      return titulo;
    },
  },
  methods: {
    guardar() {
      this.$emit("save", this.object);
    },
    eliminar() {
      this.$emit("delete", this.object.id);
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {
    date_FI: function(val) {
      this.object.finish_at = moment(val).format("LL");
    },
  },
};
</script>

<style></style>
